import script from "./TermsOfServicePage.vue?vue&type=script&setup=true&lang=js"
export * from "./TermsOfServicePage.vue?vue&type=script&setup=true&lang=js"

import "./TermsOfServicePage.vue?vue&type=style&index=0&id=93bb00c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93bb00c6"]])

export default __exports__